/** Waitlist + invite product events (spec 84 §10). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id } from './_shared.js';

export const waitlistEvents = {
  'waitlist.joined': {
    schema: z.object({
      entry_id: id,
      referred: z.boolean(),
      source: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'waitlist.referred': {
    schema: z.object({
      entry_id: id,
      referrer_code: z.string().min(1),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'invite.minted': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
